import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import RuletaDeJuegosCardImg from "../../components/UmmIApps/Cards/RuletaDeJuegosCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import RuletaJuegos from "../../components/RuletaJuegos/RuletaJuegos";
import EdadHijo from "../../components/Form/Fields/EdadHijo";
import InteresHijo from "../../components/Form/Fields/InteresHijo";
import Superheroe from "../../components/Form/Fields/Superheroe";
import LugarJuegos from "../../components/Form/Fields/LugarJuegos";

const RuletaJuegosPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    handleBack,
    setTextoInicial,
    handleInitialPromptData,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    lastPayload
  } = useActividadesContext();

  const isButtonDisabled = !(
    promptData.edad &&
    promptData.interes &&
    promptData.superheroe &&
    promptData.lugar &&
    promptData.ganador
  );
  const colorIconBack = "#336B87";

  useEffect(() => {
    const init = {
      edad: 1,
      interes: "",
      superheroe: "",
      lugar: "",
    };
    const envoltorio = promptData.envoltorio || "ruleta_juegos";
    handleInitialPromptData(init, envoltorio);
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={RuletaDeJuegosCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #9ADEF5 100%, #9ADEF5 100%)"
        }
        title="Ruleta de juegos"
        description="Actividades y temas aleatorios que fomentan el aprendizaje a través del juego."
        titleColor="#336B87"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid container spacing={2} px={{ xs: 4, md: 6, lg: 8 }}>
            <Grid item xs={12} md={6}>
              <EdadHijo />
            </Grid>
            <Grid item xs={12} md={6}>
              <InteresHijo />
            </Grid>

            <Grid item xs={12} md={6}>
              <Superheroe />
            </Grid>
            <Grid item xs={12} md={6}>
              <LugarJuegos />
            </Grid>
          </Grid>

          <Grid container spacing={2} px={{ xs: 4, md: 6, lg: 8 }}>
            <RuletaJuegos />
          </Grid>
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default RuletaJuegosPage;
